import {Component} from '@angular/core';
import {environment} from "../../../environments/environment";

@Component({
  selector: 'account',
  template: `
    <div class="login-shell">
      <!-- Zinger brand side (image + tagline are configurable via environment) -->
      <aside class="brand-side">
        <div class="brand-inner">
          <img
            *ngIf="accountPageUrl && !imageLoadError"
            class="hero"
            alt="Zinger"
            [src]="accountPageUrl"
            (error)="onImageError()"
            appStaticSrc
          />
          <div *ngIf="!accountPageUrl || imageLoadError" class="hero-fallback">
            {{ accountPageFallbackText }}
          </div>
          <div class="tagline">{{ loginPageText }}</div>
        </div>
      </aside>

      <!-- Sign-in area -->
      <main class="login-main">
        <router-outlet></router-outlet>
      </main>
    </div>
  `,
  styles: [`
    :host{ --ink:#1A1A1A; --muted:#6B7280; --line:#E5E7EB; }
    .login-shell{display:flex;min-height:100vh;background:#fff;font-family:'Inter',-apple-system,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;color:var(--ink)}
    .brand-side{flex:1.2;display:flex;align-items:center;justify-content:center;background:#F7F8FA;padding:40px}
    .brand-inner{display:flex;flex-direction:column;align-items:center;text-align:center;max-width:520px}
    .hero{width:100%;max-width:440px;height:auto;object-fit:contain}
    .hero-fallback{font-size:20px;color:var(--muted)}
    .tagline{margin-top:26px;font-size:30px;line-height:1.25;font-weight:600;color:var(--ink)}
    .login-main{flex:1;display:flex;align-items:center;justify-content:center;background:#fff;padding:24px}
    @media (max-width:860px){ .brand-side{display:none} .login-main{background:#F7F8FA} }
  `],
})
export class AccountComponent {
  title: string = 'Custom Solutions';
  imageLoadError = false;
  accountPageUrl: string = environment.accountPageImageUrl;
  accountPageFallbackText: string = environment.accountPageFallbackText;
  loginPageText: string = environment.loginPageText;

  onImageError() {
    this.imageLoadError = true;
  }
}
